import styled from "@emotion/styled";

import LiveText from "./live-text.svg";

export const LiveTag = styled.span`
  display: inline-flex;
  justify-content: center;
  align-items: center;

  inline-size: 70px;
  block-size: 32px;

  background-color: #ffca05;

  ${props => props.theme.breakpoints.down("tablet")} {
    inline-size: 61px;
    block-size: 28px;
  }
`;

export const Dot = styled.span`
  display: inline-block;

  inline-size: 13.7px;
  block-size: 13.7px;
  margin-inline-end: 4.6px;

  border-radius: 50%;

  background-color: #ffffff;

  animation: blink-animation 2s infinite;
  animation: fade-in-out 1s infinite;
  @keyframes blink-animation {
    to {
      visibility: hidden;
    }
  }

  @keyframes fade-in-out {
    0%,
    100% {
      opacity: 0;
    }
    25% {
      opacity: 1;
    }
  }

  ${props => props.theme.breakpoints.down("tablet")} {
    inline-size: 12px;
    block-size: 12px;
    margin-inline-end: 4px;
  }
`;

export const StyledLiveTag = styled(LiveText)`
  inline-size: 32.6px;
  block-size: 10.5px;

  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 37px;
    block-size: 12px;
  }
`;
